import Head from "next/head"

interface IMetaTagProps {
    title: string
    description?: string
    isIndex?: boolean
}

const MetaTag = (props: IMetaTagProps) => {
    const { isIndex = false, title, description = title } = props

    return (
        <Head>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content={isIndex ? 'index, follow' : 'noindex, nofollow'} />
            <link rel="icon" href="/favicon.ico" />
        </Head>
    )
}

export default MetaTag
